/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo } from "react";
import WatermarkImage from '../../assets/3129492.jpg';
import { getShopUrl, getExportConfig, getTrialStatus, ChargeUrl } from '../Services/CommonServices';
import { downloadDefinitionBulkResult, definitionBulkCancel, DefinitionBulkPolling, DeleteDefinitionLogs,definitionExportStatus, getDefinitionImportHistory, Definitions } from '../Services/DefinitionService';
import { environment } from '../Services/environment';
import { validConversionPrice } from '../Validation/regex';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { errorMetaModal, errorModal } from '../common/ErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import ExportStatusCard from '../common/ExportStatusCard';
import MappingModal from '../common/MappingModal';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import { useNavigate } from 'react-router-dom';
// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function ShopifyDefinition({ blockUpload,eventSource }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [mappedHeaders, setMappedHeaders] = useState({});
    const CHUNK_SIZE = 1048576; // 1MB
    const [file, setFile] = useState();
    const [logsLoading, setLogsLoading] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState();
    const [dropzoneKey, setDropzoneKey] = useState(0); // Key to force dropzone re-render
    const hasError = rejectedFiles != null;
    const validFileTypes = ['.csv','.CSV','text/csv','.xlsx','.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setFile(acceptedFiles[0])
            setRejectedFiles(_rejectedFiles[0])
        },
        [],
    );
    const [definitions, setDefinitions] = useState([]);
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [mutationType, setMutationType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [exportStatus, setExportStatus] = useState("");
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [conversionPrice, setConversionPrice] = useState();
    const [configLoading, setConfigLoading] = useState(false);
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [logs, setLogs] = useState([]);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [loadingMap, setLoadingMap] = useState({});

    const pageSize = 10;
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
    const handleChangeConversionPrice = useCallback((newValue) => { if (ValidatePrice(newValue)) { setConversionPrice(newValue) } }, []);
    
    const fileUpload = useMemo(() => !file && <s-text>Click here to upload a file</s-text>, [file]);
    
    const uploadedFile = useMemo(() => file && (
        <s-stack direction="inline" gap="small" alignment="center">
            <s-thumbnail
                alt={file.name}
                source={
                    validFileTypes.includes(file.type)
                        ? window.URL.createObjectURL(file)
                        : <s-icon type="edit" />
                }
            />
            <s-stack gap="small-100">
                <s-text>
                    {file.name}
                </s-text>
                <s-text>
                    {file.size} bytes
                </s-text>
            </s-stack>
        </s-stack>
    ), [file, validFileTypes]);

    const [vendorArray, setVendorArray] = useState([]);
    const [popoverActive, setPopoverActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const [bulkErrorActive, setBulkErrorActive] = useState(false);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [definitionDeleteStatus, setDefinitionDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitDefinitions, setSplitDefinitions] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [definitionBulkCancelStatus, setBulkCancelStatus] = useState("")
    const [emailMarketingUpdate,setEmailMarketingUpdate] = useState(undefined);
    const [selectedExportFilters, setSelectedExportFilters] = useState([]);
    const [active, setActive] = useState(false);
    const [activeResource, setActiveResource] = useState(false);
    const handleChangeModal = useCallback(() => { if (!active) {  }  setActive(!active); }, [active]);
    const handleResourceChangeModal = useCallback(() => { if (!activeResource) {  }  setActiveResource(!activeResource); }, [activeResource]);
    
    // Handle export modal visibility
    useEffect(() => {
        const modal = document.getElementById('export-modal');
        if (modal) {
            if (active && modal.showOverlay) {
                modal.showOverlay();
            } else if (!active && modal.hideOverlay) {
                modal.hideOverlay();
            }
        }
    }, [active]);

    // Handle resource modal visibility
    useEffect(() => {
        const modal = document.getElementById('resource-modal');
        if (modal) {
            if (activeResource && modal.showOverlay) {
                modal.showOverlay();
            } else if (!activeResource && modal.hideOverlay) {
                modal.hideOverlay();
            }
        }
    }, [activeResource]);
    
    const [selectedType, setSelectedType] = useState("");
      const [definitionResourceType, setDefinitionResourceType] = useState("metafield");
    const [totalDefinitionCount, setTotalDefinitionCount] = useState(null);
    const [exportFilterMsg, setExportFilterMsg] = useState(null);

    // Trial Authorization States
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);

    const [isModalActive, setIsModalActive] = useState(false);
    const [ mapModalLodaing, setMapModalLoading] = useState(false);
    const [exportModalLoading,setExportModalLoading] = useState(false);
  // Example headers
  const [shopifyHeaders,setShopifyHeaders] = useState([]);
  const [catalogHeaders,setCatalogHeaders] = useState([]);
  const [formSubmit, setFormSubmit] = useState(false);
    useEffect(() => {
        getConfigExport();
        setFile(null);
        // deleteOlderLogs();
        // statusPolling();
        getLogs();
        checkExportStatus();
        loadTrialStatus(); // Load trial authorization
    }, []);

    // Refetch export config when export completes
    useEffect(() => {
        if (exportStatus === "completed" || exportStatus === "failed") {
            // Small delay to ensure backend has updated the config
            const timer = setTimeout(() => {
                getConfigExport();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [exportStatus]);

    // ========== Trial Authorization Functions ==========
    
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            // Show banner if trial expired and no active charge
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true; // Loading state, allow temporarily
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };
    // ========== End Trial Authorization Functions ==========

    // useEffect(() => {
    //     if(!blockUpload)
    //     {
    //     GetDefinitionFields();
    //     }
    // }, [selectedType]);


    useEffect(() => {
        if(formSubmit)
        {
            handleSubmit();
        }
    }, [mappedHeaders,formSubmit]);

    // Open error modal when bulkErrorActive becomes true
    useEffect(() => {
        if (bulkErrorActive && bulkErrors.length > 0) {
            const modal = document.getElementById('bulk-error-modal');
            if (modal && modal.showOverlay) {
                modal.showOverlay();
                // Add listener to reset state when modal is closed
                const handleModalHide = () => {
                    setBulkErrorActive(false);
                };
                modal.addEventListener('hide', handleModalHide);
                return () => modal.removeEventListener('hide', handleModalHide);
            }
        }
    }, [bulkErrorActive, bulkErrors]);

    // Open metafield error modal when bulkMetaErrorActive becomes true
    useEffect(() => {
        if (bulkMetaErrorActive && bulkMetaErrors.length > 0) {
            const modal = document.getElementById('bulk-meta-error-modal');
            if (modal && modal.showOverlay) {
                modal.showOverlay();
                // Add listener to reset state when modal is closed
                const handleModalHide = () => {
                    setBulkMetaErrorActive(false);
                };
                modal.addEventListener('hide', handleModalHide);
                return () => modal.removeEventListener('hide', handleModalHide);
            }
        }
    }, [bulkMetaErrorActive, bulkMetaErrors]);


    const handleSubmit = () => {
        const isTitleMapped = definitionResourceType === "metafield" ? Object.keys(mappedHeaders).some((key) => key.toLowerCase() === "key") : Object.keys(mappedHeaders).some((key) => key.toLowerCase() === "type");
        if (isTitleMapped) {
            const jsonData = JSON.stringify(mappedHeaders);
            const formData = new FormData();
            formData.append('MappingData', jsonData);
            formData.append('File', file, file.name);
            formData.append('StoreUrl', storeUrl);
            formData.append('Type', definitionResourceType === "metafield" ?  selectedType : definitionResourceType);
            const requestOptions = {
              method: 'POST',
              body: formData,
            };
    
            fetch(endpoint + '/api/MetaDefinition/process-mappings', requestOptions)
              .then((response) => {
                if (response.status === 400) {
                  return response.json().then((errorData) => {
                    if (errorData.message.includes('metafields')) {
                      throw new Error(`Definition mapping: ${errorData.message}`);
                    }
                    else {
                      throw new Error(`Bad Request: ${errorData.message}`);
                    }
                  });
                } else if (!response.ok) {
                  throw new Error('Server Error');
                }
                return response.json();
              })
              .then((data) => {
              })
              .catch((error) => {
                if (error.message.startsWith('Bad Request')) {
                //   uploadError("server");
                }
                else if (error.message.startsWith('Metafields')) {
                //   uploadError("metafield");
                }
              })
              .finally(() => {
                setActive(false);
              });
            setActive(false);
          }
        else {
        //   setProductMappingError("Mapping the 'Handle' Shopify header is required.");
        //   setSaveTempLoading(false);
        }
      };


    useEffect(() => {
         if (eventSource) {
        eventSource.onmessage = (event) => {
            const data = event.data;
            if (data.includes("processing")) {
                setUploadBtnLoading(false);
                setIsUploadError(false);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("validating");
                setEmailMarketingUpdate(undefined);
                // Don't clear file here - let it clear only on completion/cancellation
            }
            if (data.includes("definitionValidation")) {
                const { definitionValidation } = JSON.parse(data);

                if (definitionValidation === true) {
                    setUploadBtnLoading(false);
                    setIsUploadError(false);
                    setBulkStatus("processing");
                    setProcessingMsg("calculating items");
                    setEmailMarketingUpdate(undefined);
                    // Don't clear file here - let it clear only on completion/cancellation
                } else {
                    // Validation failed - reset dropzone immediately
                    setFile(null);
                    setRejectedFiles(null);
                    setDropzoneKey(prev => prev + 1);
                    setBulkStatus("failed");
                    setUploadStatus(false);
                    setPollingResult(undefined);
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setErrModalActive(true);
                    setUploadErrors(JSON.parse(data));
                    
                }
            } else if (data.includes("definitionuploading")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("uploading");
                setStagedUploadProgress(JSON.parse(data));
                setUploadBtnLoading(false);
                
            } else if (data.includes("Definition delete")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("Definition delete");
                setDefinitionDeleteStatus(JSON.parse(data));
            } else if (data.includes("DefinitionMetafield delete")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("Metafield delete");
                setMetaDeleteStatus(JSON.parse(data));
            } else if (data.includes("bulkId")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;

                    if (status.toLowerCase() === "completed") {
                        setPollingResult(jsonObject);
                        setBulkStatus(status);
                        setUploadStatus(false);
                        getLogs();
                        // Reset dropzone for next upload
                        setFile(null);
                        setRejectedFiles(null);
                        setDropzoneKey(prev => prev + 1); // Force dropzone re-render
                    } else if (status.toLowerCase() === "canceled") {
                        setUploadStatus(false);
                        setBulkStatus(status);
                        getLogs();
                        // Reset dropzone for next upload
                        setFile(null);
                        setRejectedFiles(null);
                        setDropzoneKey(prev => prev + 1); // Force dropzone re-render
                    } else {
                        setUploadStatus(true);
                        setBulkStatus(status);
                        setPollingResult(jsonObject);
                    }
                }
            } else if (data.includes("DefinitionCatalog extract")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setCatalogExtractMsg(jsonObject);
                setProcessingMsg("Catalog extract");
                setUploadBtnLoading(false);
            } else if (data.includes("Split definitions")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Split definitions");
                setUploadBtnLoading(false);
                setSplitDefinitions(jsonObject);
            } else if (data.includes("bulkop")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject.status = "canceled") { setBulkStatus(false); setPollingResult(undefined); setBulkCancelStatus(""); getLogs(); }
                else {
                    setBulkCancelStatus(jsonObject.status);
                }
            } else if (data === "pong") {
            } else if (data === "definitionDownloadComplete") {
                setDownloadSpinner(false);
                getConfigExport();
            }
            else if (data.includes("definitionfailed")) {
                setExportStatus("failed");
                setDownloadSpinner(false);
            }
            else if (data.includes("Export")) {
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    
                }
                try{
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { type, status,completedAt } = jsonObject;
                    if (type.includes("Product")) { setMutationType("product"); }
                    else if (type.includes("Definition")) { setMutationType("definition"); setExportResult(jsonObject);}
                    if(status.toLowerCase() === "completed" || status.toLowerCase() === "failed" || status.toLowerCase() === "expired")
                    {
                        setDownloadSpinner(false);
                        setExportBtnLoading(false);
                        if(type.includes("Definition"))
                        {
                            setExportResult(jsonObject);
                            setExportStatus(status.toLowerCase());
                            setExportCompletedAt(completedAt);
                        }

                        if(type === "DefinitionExport")
                                {
                                    setDownloadSpinner(false);
                                    setExportBtnLoading(false);
                                    // window.location.href = endpoint + '/api/MetaDefinition/download-previous-export?storeUrl=' + storeUrl;
                                }
                    }
                    setExportStatus(status.toLowerCase());
                }} catch (err) {
                    console.warn("Non-JSON message received:", data);
                }
            }

        }
    }

        return () => {
            if (eventSource) {
              eventSource.onmessage = null; // Remove the event handler
            }
          };
        }, [eventSource]);

    const activator = (
        <s-button onClick={togglePopoverActive} disclosure>
            Export
        </s-button>
    );



    const bulkResponseErrorModal = (
        <s-modal size='large'
            open={bulkErrorActive}
            onClose={handleBulkErrorChangeModal}
        >
            <div slot="title">Failed definitions</div>
            {bulkErrors.map(
                ({ handle, userErrors }, index) => (
                    <s-box key={index} paddingBlockEnd="base" borderBlockEndWidth={index < bulkErrors.length - 1 ? "025" : "0"} borderColor="border">
                        <s-stack gap="extra-small">
                                    <s-text>#{index + 1}&nbsp;Handle: {handle}</s-text>
                            {userErrors.map(
                                ({ message }, index) => (
                                    <s-banner tone="critical" key={index}>
                                        <s-text>{message}</s-text>
                                    </s-banner>
                                ))}
                        </s-stack>
                    </s-box>
                ))}
        </s-modal>
    );



    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    function generateDefinitionErrorModal(errors) {
        console.log("error model meta called",errors);
        setBulkErrors(errors);
        setBulkErrorActive(true)
    }

    function generateMetafieldErrorModal(errors) {
        setBulkMetaErrors(errors);
        setBulkMetaErrorActive(true)
    }

    const [exportCompletedAt, setExportCompletedAt] = useState('');
    // const [exportModalActive, setExportModalActive] = useState(false);
    // const exportModal = (
    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Export',
    //                 onAction: exportAllDefinitions,
    //                 disabled: exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false,
    //             }}
    //             open={exportModalActive}
    //             title="Export"
    //             onClose={() => {setExportModalActive(false)}}>
    //                 <Modal.Section>
    //                     <Banner
    //                         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //                         onDismiss={false}>
    //                         <Text>
    //                             {exportStatus === "completed" ?
    //                                 "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed on " + new Date(exportCompletedAt).toLocaleDateString() + " at " + new Date(exportCompletedAt).toLocaleTimeString() + ". "
    //                                 : exportStatus === "" ?  "No previous export Found. Please export again." :  "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus + (exportStatus !== "failed" ? ". This may take a few moments." : ".")}
    //                             {exportStatus === "completed" && !downloadSpinner? <Link url="" onClick={() => {
    //                                 setDownloadSpinner(true);
    //                                 window.location.href = endpoint + '/api/MetaDefinition/download-previous-export?storeUrl=' + storeUrl;
    //                             }}>Download</Link> : downloadSpinner ? <Spinner  size="small" /> : null}
    //                         </Text>
    //                     </Banner>
    //                 </Modal.Section>
                    
    //         </Modal>
    //     </>
    // );


    const modalSelectResource = (

        <>
            <s-modal
                id="resource-modal"
                heading="Select Resource Type"
                padding="none"
            >
                <s-box padding="base">
                    <s-select
                        label="Resource Type"
                        value={definitionResourceType}
                        onChange={(e) => { setDefinitionResourceType(e.currentTarget.value); }}
                    >
                        <s-option value="metafield">Metafield</s-option>
                        <s-option value="metaobject">Metaobject</s-option>
                    </s-select>
                </s-box>
                
                <s-button
                    slot="primary-action"
                    variant="primary"
                    onClick={() => { FileUploadValidation(); handleResourceChangeModal(); }}
                    disabled={definitionResourceType === "" || definitionResourceType === undefined || uploadStatus || blockUpload ? true : false}
                    commandFor="resource-modal"
                    command="--hide"
                >
                    Next
                </s-button>
            </s-modal>
        </>
    );
            

    const modal = (
        
        <>
            <s-modal
                id="export-modal"
                heading="Export"
            >
                <s-box padding="none">
                    {exportModalLoading === false ?
                        <s-stack gap="base">
                            <s-select
                                label="Resource Type"
                                value={definitionResourceType}
                                onChange={(e) => { setDefinitionResourceType(e.currentTarget.value); }}
                            >
                                <s-option value="metafield">Metafield</s-option>
                                <s-option value="metaobject">Metaobject</s-option>
                            </s-select>
                            {definitionResourceType === "metafield" ? 
                            <s-select
                                label="Type"
                                value={selectedType}
                                onChange={(e) => { setSelectedType(e.currentTarget.value)} }
                            >
                                {definitions.map((option) => (
                                    <s-option key={option} value={option}>{option}</s-option>
                                ))}
                            </s-select> : null }
                        </s-stack>
                        
                        : <s-box padding="large">
                            <s-stack alignment="center">
                                <s-spinner size="large" />
                            </s-stack>
                        </s-box>}
                    {exportFilterMsg !== null && (
                        <s-box paddingBlockStart="base">
                            <s-text color="success">{exportFilterMsg}</s-text>
                        </s-box>
                    )}
                </s-box>

                <s-button
                    slot="primary-action"
                    variant="primary"
                    onClick={() => { exportDefinitionsByType(); handleChangeModal(); }}
                    disabled={!["completed", "", "canceled", "expired","failed"].includes(exportStatus) || !!uploadStatus || !!blockUpload || exportModalLoading}
                    commandFor="export-modal"
                    command="--hide"
                >
                    Export
                </s-button>
            </s-modal>
        </>
    );

    return (
        <s-page heading='Definitions'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                onClick={() => { QueryOwnerTypes(); handleChangeModal() }}
                disabled={exportStatus !== "running" && !uploadStatus && !blockUpload ? false : true}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportBtnLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus}${exportStatus !== "failed" && exportStatus !== "canceled" ? ". This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>

            {/* Trial Expired Banner */}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />

            {/* Main Card - Two columns layout with grid */}
            <s-stack gap="base">
            <s-section padding="base">
                <s-box padding="none">
                    <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                        <s-grid-item gridColumn="span 6">
                            <s-stack gap="small">
                                {/* DropZone Section */}
                                <s-stack gap="small-100">
                                    <s-heading>Upload File</s-heading>
                                    <s-link onClick={() => openSampleFile()}>
                                        Download a sample file
                                    </s-link>
                                    
                                    <s-drop-zone
                                        key={dropzoneKey}
                                        multiple={false}
                                        accept=".csv,.xlsx"
                                        onInput={(event) => {
                                            const files = event.currentTarget.files;
                                            if (files && files.length > 0) {
                                                handleDropZoneDrop([], Array.from(files), []);
                                            }
                                        }}
                                    >
                                        {uploadedFile}
                                        {fileUpload}
                                    </s-drop-zone>
                                    
                                    <s-text color="subdued">
                                        Accepts .csv/.xlsx format. Maximum size: 20 MB
                                    </s-text>
                                </s-stack>

                                {/* Action Buttons Section */}
                                <s-stack gap="small-100">
                                    <s-stack direction="inline" gap="small">
                                        <s-button
                                            variant="primary"
                                            disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                            loading={uploadBtnLoading}
                                            onClick={() => handleResourceChangeModal()}
                                        >
                                            Upload
                                        </s-button>
                                        {/* <s-button 
                                            variant="secondary" 
                                            onClick={() => openSampleFile()}
                                        >
                                            Download sample
                                        </s-button> */}
                                    </s-stack>
                                    
                                    {hasError && (
                                        <s-text as="p" tone="critical">
                                            {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                        </s-text>
                                    )}
                                </s-stack>
                            </s-stack>
                        </s-grid-item>
                        
                        <s-grid-item gridColumn="span 6">
                            {/* Note Section with Image Watermark */}
                            <div style={{ position: 'relative'}}>
                                {/* Watermark Image Background */}
                                <div 
                                    style={{
                                        position: 'absolute',
                                        bottom: '-120px',
                                        right: '10px',
                                        width: '300px',
                                        height: '300px',
                                        backgroundImage: `url(${WatermarkImage})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'bottom right',
                                        opacity: '0.15',
                                        pointerEvents: 'none',
                                        zIndex: 0
                                    }}
                                />
                                
                                {/* Note Content - On top of watermark */}
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <s-stack gap="small-100">
                                        <s-heading>Note</s-heading>
                                        <s-unordered-list>
                                            <s-list-item>
                                                Metafields are separate column headers with the format: <s-text type="strong">definition/namespace/metafield-name/type</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                To delete a metafield, end the header with <s-text type="strong">'/delete'</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                Image urls in metafields can be comma(,) separated in the first row of the product.
                                            </s-list-item>
                                            <s-list-item>
                                                Image urls from Google Drive and Dropbox share links are automatically updated by us to be accepted in Shopify
                                            </s-list-item>
                                        </s-unordered-list>
                                    </s-stack>
                                </div>
                            </div>
                        </s-grid-item>
                    </s-grid>
                </s-box>
            </s-section>
            </s-stack>

            <ImportProcessing
                bulkStatus={bulkStatus}
                uploadStatus={uploadStatus}
                pollingResult={pollingResult}
                setErrModalActive={setErrModalActive}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                stagedUploadProgress={stagedUploadProgress}
                splitItems={splitDefinitions}
                productDeleteStatus={definitionDeleteStatus}
                metaDeleteStatus={metaDeleteStatus}
                productBulkCancelStatus={definitionBulkCancelStatus}
                cancelBulk={cancelBulk}
                generateProductErrorModal={generateDefinitionErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
                emailMarketingUpdate={emailMarketingUpdate}
            />

             {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running"  ?

                <ExportStatusCard exportResult={exportResult} progress={0} exportConfig={exportConfig} currentRoute="definition" />

                : null}
           
            
            {/* Import History Section */}
            <s-box paddingBlockStart="base">
                <s-section padding="none">
                
                
                <ImportHistory
                    logs={logs}
                    generateProductErrorModal={generateDefinitionErrorModal}
                    generateMetafieldErrorModal={generateMetafieldErrorModal}
                    downloadResult={downloadResult}
                    loadingMap={loadingMap}
                    logsLoading={logsLoading}
                    currentRoute="definition"
                />
                
                {logs.length !== 0 && (
                    <s-stack direction="inline" align="center">
                        <s-pagination
                            has-previous={prvButton}
                            onPrevious={() => prev()}
                            has-next={nxtButton}
                            onNext={() => next()}
                        />
                    </s-stack>
                )}
                
                {errorModal({ bulkErrorActive, handleBulkErrorChangeModal, bulkErrors, currentRoute: 'definition' })}
                {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })}
            </s-section>
            </s-box>
            {/* {exportModal} */}
            {modal}
            {modalSelectResource}
            <MappingModal
                active={isModalActive}
                setActive={setIsModalActive}
                shopifyHeaders={shopifyHeaders}
                catalogHeaders={catalogHeaders}
                setTypeSelected = {setSelectedType}
                mapModalLodaing={mapModalLodaing}
                setMappedHeaders={setMappedHeaders}
                setFormSubmit={setFormSubmit}
                currentRoute={definitionResourceType+"_definition"}
                blockUpload={blockUpload}
            />
            {bulkErrors.length > 0 ? bulkResponseErrorModal : null}
            {isUploadError ? <ValidationErrorModal
                errModalActive={errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            /> : null}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />

            {/* {resultDownloadErrorToast} */}

        </s-page>
        // </Frame>
    );

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadDefinitionBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function openSampleFile() {
        window.open(environment.sampleDefinitionsFile, '_blank');
      }

    async function cancelBulk(bulkId) {
        definitionBulkCancel(storeUrl, bulkId).then(function (result) {
            setBulkCancelStatus("canceling");
            getLogs();
        });
    }

    async function uploadChunk(chunk, chunkIndex, totalChunks) {
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);

        const response = await fetch(endpoint + '/api/MetaDefinition/file-validation-chunk', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Chunk upload failed');
        }
    }

    async function FileUploadValidation() {
        console.log("file upload validation called",definitionResourceType);
            setFormSubmit(false);
            if (file !== null) {
                QueryOwnerTypes();
                setBulkCancelStatus("");
                setIsUploadError(false);
                setUploadErrors(false);
                setBulkErrors([]);
                setUploadBtnLoading(true);

                const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
                let allChunksUploaded = true;

                try {
                    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                        const start = chunkIndex * CHUNK_SIZE;
                        const end = Math.min(start + CHUNK_SIZE, file.size);
                        const chunk = file.slice(start, end);

                        try {
                            await uploadChunk(chunk, chunkIndex, totalChunks);
                        } catch (error) {
                            allChunksUploaded = false;
                            setUploadBtnLoading(false);
                            setIsUploadError(true);
                            setUploadErrors({
                                errorType: "exception",
                                errors: ["File upload failed. Please try again."]
                            });
                            setErrModalActive(true);
                            break;
                        }
                    }

                    if (allChunksUploaded) {
                        const formData = new FormData();
                        formData.append('fileName', file.name);
                        formData.append('totalChunks', totalChunks);
                        formData.append('storeUrl', storeUrl);
                        formData.append('type', definitionResourceType === "metafield" ? selectedType : definitionResourceType);

                        fetch(endpoint + '/api/MetaDefinition/read-catalog-headers', {
                            method: 'POST',
                            body: formData,
                        })
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error('Network response was not ok');
                                }
                                return response.json();
                            })
                            .then(data => {
                                // const defaultCSVHeaders = ["null"];
                                const fileHeaders = [data?.fileHeaders];
                                setCatalogHeaders(...fileHeaders);
                                const headersShopify = [data?.shopifyHeaders];
                                setShopifyHeaders(...headersShopify);
                                setIsModalActive(true);
                                setUploadBtnLoading(false);
                            })
                            .catch(error => {
                                setUploadBtnLoading(false);
                                setIsUploadError(true);
                                setUploadErrors({
                                    errorType: "exception",
                                    errors: ["Failed to process file headers. Please check your file format."]
                                });
                                setErrModalActive(true);
                            });
                    }
                } catch (error) {
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setUploadErrors({
                        errorType: "exception",
                        errors: ["An error occurred while uploading the file. Please try again."]
                    });
                    setErrModalActive(true);
                }
            }
        
    }


    function deleteOlderLogs() {
        DeleteDefinitionLogs(storeUrl).then(function (result) {
        });
    }


    function statusPolling() {
        DefinitionBulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                console.log("Polling status:", status);
                if (status.toLowerCase() === "completed") {
                    setPollingResult(result);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    function checkExportStatus() {
        definitionExportStatus(storeUrl).then(function (result) {
            setDownloadSpinner(true);
            console.log("Export status result:", result);
            if (result !== null) {
                var status = result?.status?.toLowerCase();
                var type = result.type
                if (status === "completed" && type === "definition") {
                    setMutationType(type);
                    setExportStatus(status)
                    setBulkStatus(status);
                    setExportCompletedAt(result.completedAt)
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
                else if (type === "definition" && status === "running" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (type === "definition" && status === "processing" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (status === "failed" && type === "definition") {
                    setDownloadSpinner(false);
                    setMutationType(type);
                    setExportResult(result);
                    setBulkStatus(status);
                    setExportStatus("failed")
                    
                }

                else if (status === "failed" && type === "product") {
                    setExportStatus("completed")
                    setDownloadSpinner(false);
                }

                else if (type !== "definition" && status === "running" )
                {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                }

                else {
                    // setMutationType(type);
                    // setExportStatus("")
                    // checkPrevExport();
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
            }
            else
            {
                setDownloadSpinner(false);
            }
        })
    }
    function ValidatePrice(price) {
        if (validConversionPrice.test(price)) {
            return true;
        }
        else {
            return false;
        }

    }

    function getLogs() {
        setLogsLoading(true);
        getDefinitionImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount((result.totalCount / pageSize) + 1);
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }



    function getConfigExport() {
        getExportConfig(storeUrl,"definition").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
                if (result.status === "completed") {
                    setExportBtnLoading(false);
                    setDownloadSpinner(false);
                    
                    setExportStatus(result.status);
                    
                }
                else if (result.status  === "failed") {
                    setExportBtnLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                }
                else {
                    setExportBtnLoading(true);
                    setExportStatus(result.status);
                }
            }
        });
    }

    function QueryOwnerTypes() {
        setExportModalLoading(true);
        Definitions(storeUrl,"metafield").then(function (result) {
            if (result !== null) {
                setSelectedType(result[0]);
                setTotalDefinitionCount(1);
                setDefinitions(result);
                setExportModalLoading(false);
            }
            else
            {
                setExportModalLoading(false);
            }
        });
    }

    // function GetDefinitionFields() {
    //     setMapModalLoading(true);
    //     try {
    //         DefinitionFields(storeUrl, selectedType).then(function (result) {
    //             if (result !== null) {
    //                 setShopifyHeaders(result);
    //                 setMapModalLoading(false);
    //             }
    //         });
    //     } catch (error) {
    //         setMapModalLoading(false);
    //     }
    // }

    function exportDefinitionsByType() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            handleChangeModal(); // Close the export modal
            return;
        }

        setExportStatus('running');
        // setDownloadSpinner(true);
        setExportBtnLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        const url = new URL(endpoint + '/api/MetaDefinition/metafield-definitions-export');
        url.searchParams.append('storeUrl', storeUrl);
        url.searchParams.append('type', definitionResourceType === "metafield" ? selectedType : definitionResourceType);
        fetch(url, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                    setExportBtnLoading(false);
                }
                else if (response.status === 400) {
                    setExportBtnLoading(false);
                    return response.statusText
                }
            })
            .catch(error => {
                setExportBtnLoading(false);
                return []
            })
    }

    
    
}

